import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes, useTheme } from 'styled-components';
import { ReactComponent as Pin } from '../../assets/pin.svg';
const LoadingDataStyle = styled.div `
  position: absolute;
  z-index: 99;
  left: 46%;
  top: 15px;
  border: 2.5px solid #dfdbd8;
  border-radius: 4.5px;
  cursor: pointer;
  margin: 8px 10px 22px;
  padding: 10px;
  width: 60px;
  height: 10px;
  background-color: #F2F2F2;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
const fadeAnimation = keyframes `
 0% {
   opacity: 1;
   top: 22px;
   transform: scale(140%)
  }
  50% {
    top: 15px;
    transform: scale(200%)
  }
  100% {
    opacity: 1;
    top: 22px;
    transform: scale(140%)
  }
`;
const PinStyle = styled(Pin) `
   position: relative;
   opacity: 0;
   top: 22px;
   transform: scale(140%)
   fill: ${props => props.fill};
   animation: ${fadeAnimation} 850ms ease-in infinite;
   animation-delay: ${props => props.position + '00ms'};
`;
const LoadingData = () => {
    const theme = useTheme();
    return (_jsxs(LoadingDataStyle, { children: [_jsx(PinStyle, { fill: theme.colors.mainColor, position: 1 }), _jsx(PinStyle, { fill: theme.colors.secondaryColor, position: 2 }), _jsx(PinStyle, { fill: theme.colors.doneColor, position: 3 })] }));
};
export default LoadingData;
